import React from "react";
import Card from "components/card/Card";
import Table from 'components/table/Table';
import { topUpFields } from '../../../models/data';

export default function TopupTable({
    isLoading = false, reportDate = null, filter = false, setReportDate = null, setFilterState = null, addControl, deleteFn, editFn, data = [], disableDelete = false, disableEdit = false, disableAdd = false
}) {

    const tableProps = {
        ...topUpFields,
        data,
        useBasicTemplate: false,
        toolbarIsVisible: true,
        pagingIsAllowed: true,
        fontSize: 13,
        pageSize: 10,
        loading: isLoading,
        disableAdd,
        addControl,
        addToolTip: '',
        showFilter: filter,
        disableDelete,
        disableEdit,
        actionsPosition: 0,
        deleteFn,
        editFn,
        filename: 'TopupHistory',
    }

    return (
        <Card
            w='100%'
            px='15px'
            py='15px'
            overflowX={{ sm: "scroll", lg: "hidden" }}>
            <Table {...tableProps} />
        </Card>
    );
}
